import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const Person2StateFalseNotiTrueIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "Person2StateFalseNotiTrueIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M18.5286 22C17.8934 22 17.3781 21.4749 17.3781 20.8267V18.0409C17.3781 17.0165 16.5614 16.184 15.557 16.184H7.12155C6.1176 16.184 5.30088 17.0165 5.30088 18.0409V20.8267C5.30088 21.4749 4.78557 22 4.15044 22C3.51531 22 3 21.4749 3 20.8267V18.0409C3 15.7229 4.84922 13.8374 7.12155 13.8374H15.557C17.8298 13.8374 19.679 15.7229 19.679 18.0409V20.8267C19.679 21.4749 19.1637 22 18.5286 22Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.5538 8.49275C13.1937 9.37996 12.3379 10.0062 11.3395 10.0062C10.0173 10.0062 8.94176 8.90914 8.94176 7.56025C8.94176 6.21212 10.0173 5.11528 11.3395 5.11528C11.8152 5.11528 12.2563 5.26121 12.6294 5.50588C12.6445 4.66412 12.8766 3.88354 13.2546 3.19471C12.6682 2.92588 12.023 2.76856 11.3395 2.76856C8.74891 2.76856 6.64088 4.91855 6.64088 7.56025C6.64088 10.2027 8.74892 12.3528 11.3395 12.3528C13.0431 12.3528 14.5235 11.4137 15.3473 10.0256C14.6329 9.66781 14.0176 9.14417 13.5538 8.49275Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.474 9.19223C19.4214 9.19223 21 7.58219 21 5.59611C21 3.61003 19.4214 2 17.474 2C15.5267 2 13.9481 3.61003 13.9481 5.59611C13.9481 7.58219 15.5267 9.19223 17.474 9.19223Z"
        fill="#FC3B26"
      />
    </svg>
  );
};

export default Person2StateFalseNotiTrueIcon;
